import { invalidateQuizRevisionConversations } from '../services/quizRevisionService';

/**
 * Archives the student's revision conversations after a reassign ("Rehacer"), since the
 * reset never notifies tangerine-ai on its own. Gated by `isAiEnabled` (the course has AI)
 * so we don't call tangerine-ai for courses without AI, where it would always fail.
 * Best-effort: failures are swallowed so they can never block or revert the reset.
 */
export async function invalidateQuizRevisionOnReassign({ quizJobGuid, isAiEnabled }) {
  if (!quizJobGuid || !isAiEnabled) {
    return;
  }

  try {
    await invalidateQuizRevisionConversations(quizJobGuid);
  } catch (error) {
    console.error('[invalidateQuizRevisionOnReassign] Failed to invalidate quiz revision conversations:', error);
  }
}
